import React from "react";
import { TransactionStatus } from "shared/enums/TransactionStatus";
import { PurchaseConfirmationPropTypes } from "../../types";
import { useCopies } from "shared/hooks/useCopies";
import TicketStatus from "shared/enums/TicketStatus";
import Icon from "assets/icons";
import { ConfirmationPageEntityType } from "../../../enum";

function MessageFooter(props: PurchaseConfirmationPropTypes) {
  const copies = useCopies();

  if (
    !(
      props.purchaseOrder?.transaction?.status === TransactionStatus.PRE_AUTHORIZED ||
      (props.ticketStatus === TicketStatus.COMPLETED && props.myExperienceLoginUrl) ||
      props.shouldReloadAfterMeetingPurchase
    )
  )
    return null;

  return (
    <div className="purchaseConfirm_footerMsg">
      {props.purchaseOrder?.transaction?.status === TransactionStatus.PRE_AUTHORIZED && (
        <p className="purchaseConfirm_footerMsg--text">
          <Icon.InfoCircleThick /> {copies.get("payment.will.be.processed")}
        </p>
      )}
      {props.ticketStatus === TicketStatus.COMPLETED && props.myExperienceLoginUrl && (
        <React.Fragment>
          {props.entityType === ConfirmationPageEntityType.GET_TICKLET && (
            <p className="purchaseConfirm_footerMsg--text">{copies.get("ticket.purchase.auto.login.message")}</p>
          )}
          {props.entityType === ConfirmationPageEntityType.TICKET_CHANGE && !props.approvalPending && (
            <p className="purchaseConfirm_footerMsg--text">{copies.get("ticket.upgrade.auto.login.message")}</p>
          )}
        </React.Fragment>
      )}
      {props.shouldReloadAfterMeetingPurchase && (
        <p className="purchaseConfirm_footerMsg--text">{copies.get("buy.meeting.dashboard.reload.message")}</p>
      )}
    </div>
  );
}

export default MessageFooter;
